<template>
	<Col>
		<Row class="width-100 flex-align-center flex-justify-space-between mb-6">
			<h5>Icon</h5>
			<Row class="flex-align-center tabs-container">
				<AnemicButton
					tile
					class="px-2 tab-button"
					v-for="(tab, i) in tabs"
					@click="selectedTabIndex = i"
					:key="`customize-notification-tab-${i}`"
					:class="{ selected: selectedTabIndex === i, 'ml-1': i !== 0 }"
				>
					{{ tab.title }}
				</AnemicButton>
			</Row>
		</Row>
		<v-slide-x-transition mode="out-in">
			<component
				:is="selectedTab.component"
				v-if="selectedTab.component"
				:selectedEntityId="selectedEntityId"
				@change-icon="(payload) => onChangeIcon({ ...payload, source: selectedTab.source })"
			/>
		</v-slide-x-transition>
	</Col>
</template>

<script>
import CustomizeNotificationMdiIcon from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationMdiIcon.vue';
import NotificationCustomIconUpload from '@/components/BlockEditorNotification/CustomizeTabs/NotificationCustomIconUpload.vue';
import CustomizeNotificationAppIcon from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationAppIcon.vue';
import CustomizeNotificationAvatarIcon from '@/components/BlockEditorNotification/CustomizeTabs/CustomizeNotificationAvatarIcon.vue';

export default {
	name: 'CustomizeNotificationSettings',
	components: {
		CustomizeNotificationMdiIcon,
		NotificationCustomIconUpload,
		CustomizeNotificationAppIcon,
		CustomizeNotificationAvatarIcon,
	},
	props: {
		iconMetadata: { type: Object, default: () => ({ source: null, entity_id: null }) },
	},
	computed: {
		tabs() {
			return [
				{ title: 'Icon', component: CustomizeNotificationMdiIcon, source: 'mdi' },
				// { title: 'Custom', component: NotificationCustomIconUpload, source: 'custom' },
				{ title: 'Avatar', component: CustomizeNotificationAvatarIcon, source: 'avatar' },
				// { title: 'App', component: CustomizeNotificationAppIcon, source: 'app' },
			];
		},
		selectedTab() {
			return this.tabs[this.selectedTabIndex];
		},
		selectedEntityId() {
			return this.iconMetadata.entity_id;
		},
	},
	methods: {
		onChangeIcon(payload) {
			this.$emit('change-icon', payload);
		},
	},
	created() {
		const sourceTabIndex = this.tabs.findIndex((tab) => tab.source === this.iconMetadata.source);
		this.selectedTabIndex = sourceTabIndex !== -1 ? sourceTabIndex : 0;
	},
	data() {
		return {
			selectedTabIndex: 0,
		};
	},
};
</script>
<style scoped lang="scss">
.tabs-container {
	padding: 2px 3px;
	border-radius: 6px;
	background: #f9fafc;
	border: 1px solid #e7eaf3;
}
.tab-button {
	height: 22px !important;
	font-size: 12px !important;
	color: #666767 !important;
	border-radius: 6px !important;
	font-weight: normal !important;
	letter-spacing: 0px !important;
	text-transform: none !important;
	background: #f9fafc !important;
	transition: var(--transition-time) !important;
	&.selected {
		color: #6160f2 !important;
		background: #ffffff !important;
		border: 1px solid #e7eaf3 !important;
		transition: var(--transition-time) !important;
		box-shadow: 0px 1px 2px #00000029 !important;
	}
}
</style>
